import React from "react";
import "./Legal.css";
import { FiShield, FiEye, FiCpu, FiCheckCircle } from "react-icons/fi";

export default function Compliance() {

  // Professional Legal Version ID
  const legalId = "BAILCP-V-CM-2.2"; // CM = Compliance
  const lastUpdated = "Dec 10, 2025";

  return (
    <div className="legal-page">
      <h1>Compliance</h1>

      {/* Legal Version / ID */}
      <div className="legal-meta">
        <span>Legal ID: {legalId}</span>
        <span>Last Updated: {lastUpdated}</span>
      </div>

      <p>
        BodhAI is committed to meeting global legal, ethical, and industry 
        standards to ensure safety, fairness, and accessibility for all users.
      </p>

      <ul className="legal-list">
        <li>
          <FiShield className="legal-icon" />
          Compliance with major data protection laws including GDPR, DPDP, and COPPA.
        </li>

        <li>
          <FiEye className="legal-icon" />
          Accessibility aligned with WCAG standards for inclusive learning environments.
        </li>

        <li>
          <FiCpu className="legal-icon" />
          Responsible AI practices that avoid harmful, misleading, or biased outputs.
        </li>

        <li>
          <FiCheckCircle className="legal-icon" />
          Supports educational & industry guidelines followed by institutions worldwide.
        </li>
      </ul>

      <p>
        Our compliance framework evolves continuously to align with 
        new regulations, technologies, and ethical expectations.
      </p>
    </div>
  );
}
